import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { getNetworkResponseError } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApiScheduled } from './sendEvent'

const responseParser = (data: any) => {
  console.log(data, 'datacheckk:::::::')
  if (data) {
    console.log(data, 'isStatusOK', data?.data)
    return data
  } else {
    console.log('else', data)
    throw getNetworkResponseError(data?.data)
  }
}
export const getAgentUserInformation = (tokens: any, agentUserLoginId: string) => {
  const config = apiConfig(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers.userIDToken = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-tile-info'] = tileInfo?.[RootStore?.consents?.appType]
  const data = JSON.stringify({
    type: '1',
    value: agentUserLoginId,
  })

  const request: Request<{}> = {
    apiPath: `${APIEndPoints.getAgentInformation}`,
    method: 'POST',
    config: config,
    cache: false,
    body: data,

    //body: getAgentInformationRequest(agentUserLoginId),
  }
  sendEventApiScheduled(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log('HTAG DATA getAgentUserInformation', data)
      console.log(responseParser(data), 'newData')
      const newData = responseParser(data)
      const rawData = newData?.data

      const nResp = {
        agentUserLoginId: rawData?.loginId || '',
        agentUserName: rawData?.name || '',
        gender: rawData?.gender,
        dob: rawData?.dob,
        agentMobileNumber: rawData?.mobileNumber || '',
        agentEmailId: rawData?.emailId,
        mobileCountryCode: rawData?.countryCode || 91,
        agentStatus: rawData?.status,

        // Mapping the nested 'agent' object to your AgentDetails model
        agent: rawData?.agent
          ? {
              name: rawData.agent.name,
              id: rawData.agent.id,
              city: rawData.agent.city,
              stateCode: rawData.agent.stateCode,
              pinCode: rawData.agent.pinCode ? String(rawData.agent.pinCode) : null,
              latitude: rawData.agent.latitude,
              longitude: rawData.agent.longitude,
              address: rawData.agent.address,
            }
          : null,

        adminUser: newData?.data?.adminUser,
        agentAuthorization: newData?.data?.agent?.authorization,

        // Mapping identity
        aadhaar: rawData?.aadhaar,
        panNumber: rawData?.panNumber,
        entityType: rawData?.entityType,

        // Root level address fields
        agentUserStateCode: rawData?.stateCode,
        agentUserCity: rawData?.city,
        agentUserPincode: rawData?.pinCode ? String(rawData?.pinCode) : null,
      }

      // const nResp = {
      //   agentUserLoginId: newData?.data?.loginId,
      //   agentUserName: newData?.data?.name,

      //   gender: newData?.data?.gender,
      //   dob: newData?.data?.dob,
      //   // parentOnboardingId: newData?.data?.dob,
      //   agentMobileNumber: newData?.data?.mobileNumber,
      //   agentEmailId: newData?.data?.emailId,
      //   mobileCountryCode: newData?.data?.countryCode,
      //   agentStatus: newData?.data?.status,
      //   adminUser: newData?.data?.adminUser,
      //   agentAuthorization: newData?.data?.agent?.authorization,
      //   agentUserStateCode: newData?.data?.agent?.stateCode,
      //   agentUserCity: newData?.data?.agent?.city,
      //   agentUserPincode: newData?.data?.agent?.pinCode,
      //   // agentUserRoleType: newData?.data?.dob,
      //   // agentUserDealershipName: newData?.data?.dob,
      //   // agentUserDealerCity: newData?.data?.dob,
      //   // agentUserDealerState: newData?.data?.dob,
      //   // agentUserDealerPinCode: newData?.data?.dob,
      //   // agentUserDealerStoreCode: newData?.data?.dob,
      //   // authorizationCode: newData?.data?.dob,
      //   // aadhaar: Aadhaar,
      //   ...newData?.data,
      // }
      console.log(nResp, 'nResp::', newData?.data?.loginId)
      return nResp
    })
    .then((response) => {
      sendEventApiScheduled(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApiScheduled(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      return responseParser(err)
    })
}

const tileInfo = {
  '0': 'AEPS',
  '1': 'DMR',
  '2': 'REFUND',
}

// import { executeRequest, Request } from '@jfs/network'
// import { RootStore } from '../data/store'
// import { getNetworkResponseError, isStatusOK } from '../util/utill'
// import { APIEndPoints } from './APIEndPoints'
// import { apiConfig } from './config'
// import { sendEventApiScheduled } from './sendEvent'

// const responseParser = (data: any) => {
//   if (isStatusOK(data)) {
//     return data?.data
//   } else {
//     throw getNetworkResponseError(data?.data)
//   }
// }
// export const getAgentUserInformation = (tokens: any, agentUserLoginId: string) => {
//   const config = apiConfig(tokens)
//   config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
//   config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
//   config.headers.userIDToken = RootStore?.bcAppInfo?.userIdentifier
//   config.headers['x-tile-info'] = tileInfo?.[RootStore?.consents?.appType]

//   const request: Request<{}> = {
//     apiPath: `${APIEndPoints.getAgentInformation}${agentUserLoginId}`,
//     method: 'GET',
//     config: config,
//     cache: false,
//     //body: getAgentInformationRequest(agentUserLoginId),
//   }
//   sendEventApiScheduled(tokens, request, {
//     status: 'INITIATED',
//   })
//   return executeRequest(request)
//     .then((data) => {
//       console.log('HTAG DATA getAgentUserInformation', data)
//       return responseParser(data)
//     })
//     .then((response) => {
//       sendEventApiScheduled(tokens, request, {
//         status: 'SUCCESS',
//       })
//       return response
//     })
//     .catch((err) => {
//       sendEventApiScheduled(tokens, request, {
//         status: 'FAILED',
//         errorDescription: err,
//       })
//       return responseParser(err)
//     })
// }

// const tileInfo = {
//   '0': 'AEPS',
//   '1': 'DMR',
//   '2': 'REFUND',
// }
